export default "__VITE_ASSET__BAh8wDyx__"